import i18n from '../../locales/index'
import restful from '@/store/vuex'

const state = {
  ...restful.states('product_unit_switch')
}

const getters = {
  ...restful.getters('product_unit_switch')
}

const actions = {
  ...restful.actions('product_unit_switches')
}

const mutations = {
  ...restful.mutations('product_unit_switch')
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
